type AnalyticsAttributes = Record<string, unknown>;
type AnalyticsEnabled = () => boolean;
type AnalyticsSender = (command: string, action: string, params?: AnalyticsAttributes) => void;

class AnalyticsTracker {
  constructor(
    private readonly isEnabled: AnalyticsEnabled,
    private readonly send: AnalyticsSender
  ) {}

  track =
    (area: string) =>
    (action: string, attributes: AnalyticsAttributes = {}) => {
      if (!this.isEnabled()) {
        return;
      }

      this.send('event', `${area}_${action}`, {
        category: area,
        ...attributes,
      });
    };
}

const analyticsTracker = new AnalyticsTracker(
  () => Boolean(window['__ANALYTICS_ENABLED__']),
  (command, action, params) => gtag(command, action, params)
);

export const { track } = analyticsTracker;
